var map = {
	"./business-bg.jpg": "8f35",
	"./business0.jpg": "c3e2",
	"./business1.jpg": "6a57",
	"./business2.jpg": "799c",
	"./business3.jpg": "1f0c",
	"./contactus-bg.jpg": "6e6f",
	"./history-bg.jpg": "ed60",
	"./home_banner.jpg": "ff77",
	"./introduce.jpg": "b070"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";